import { Link } from "react-router-dom";
import { ArrowRight, ListChecks } from "lucide-react";
import { track } from "@/lib/track";

export default function QuizBanner() {
  return (
    <section className="px-5 py-16 sm:py-20">
      <div className="max-w-5xl mx-auto rounded-3xl border border-gold/30 bg-obsidian-800/60 grain p-8 sm:p-12 relative overflow-hidden">
        <div className="absolute -top-24 -right-24 w-64 h-64 rounded-full bg-gold/10 blur-3xl" aria-hidden="true" />
        <div className="grid sm:grid-cols-[1fr,auto] gap-8 items-center relative">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold flex items-center gap-2">
              <ListChecks className="w-4 h-4" /> Free · 10 questions · about 2 minutes
            </p>
            <h2 className="font-display text-2xl sm:text-4xl font-bold text-white mt-4" data-testid="quiz-banner-heading">
              How solid are your marketing foundations?
            </h2>
            <p className="text-slate-300 text-sm sm:text-base leading-relaxed mt-4 max-w-xl">
              Take the Marketing Foundations Check: get your score, your strongest area, and the one gap worth
              fixing first — with a practical action you can take today.
            </p>
            <p className="text-slate-500 text-xs mt-3">A preliminary self-check, not a verified audit.</p>
          </div>
          <Link
            to="/quiz"
            data-testid="quiz-banner-cta"
            onClick={() => track("quiz_banner_clicked", { placement: "homepage" })}
            className="shrink-0 rounded-full bg-gold text-obsidian font-display font-bold px-8 py-4 hover:bg-gold-bright transition-colors flex items-center gap-2 justify-center"
          >
            Take the Free Check <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
